/*
 * Authors: mariushirjanu, Koen
 * Created: 30/10/2015
 * Upgraded: 20/03/2023
 */
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../../shared/formly/ga-formly.service';
import { OrderEntryWebshopService } from '../../webshop/order-entry-webshop.service';
import { OrderEntryInvoiceService } from '../invoice/order-entry-invoice.service';

interface IOvernightModel {
  overnight:boolean;
}

@Component({
  selector: 'order-location-overnight',
  template: `
    <div class="overnight" *ngIf="fields">
      <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
      <div class="cost-info"><i class="fa fa-exclamation-circle table-warning-icon"></i>&nbsp;<span translate>ORDERENTRY.SHIPPING.OVERNIGHT_COST</span></div>
    </div>
  `
})
export class OrderLocationOvernightComponent implements OnInit {
  @Input() public locationToModel:OrderEntryInvoiceService;

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:IOvernightModel;
  public loading:boolean;

  constructor(
    private formlyService:GaFormlyService,
    private orderEntryWebshopService:OrderEntryWebshopService
  ) {
    /***/
  }

  public ngOnInit():void {
    if (this.orderEntryWebshopService.shopContext?.allowOvernightShipment) {
      this.model = {
        overnight: this.locationToModel.overnight
      };
      this.fields = this.createFields();
    }
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aCheckbox('overnight', 'ORDERENTRY.SHIPPING.OVERNIGHT')
        .build()
    ];
  }
}